































































































import { Component  } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import {  InfoState } from '@/core/core.store';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';

const cssPrefix = 'maintainance-key';

@Component({
  components: {
    SwTextfield,
    SwButton,
    SwIcon,
  }, directives: {
    tooltip,
  },
})

export default class GetMaintainanceKey extends SwExtendedVue {
  // ispSwitch : boolean = true;
  cssPrefix = cssPrefix;
  serNumber = '';
  authCode = '';
  showError : boolean = false;
  maintainKey = '';
  showResult : boolean = false;
  created() {
    console.warn('created');
  }
  submit() {
    if (this.isValidInput()) {
      const request = {
        serNo : this.serNumber,
        authCode : this.authCode,
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('MswProductsStoreModule/getMaintainanceKeyValue', request)
      .then((res : any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          if (res.content.maintainenceKey === '') {
            const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.maintainceKey.notApplicable')
            .toString()) };
            this.$store.commit('enqueueMessage', message);
          } else {
            this.maintainKey = res.content.maintainenceKey;
            this.showResult = true;
          }
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
        console.warn(res);
      });
    }
  }
  clear() {
    this.authCode = '';
    this.serNumber = '';
    this.showResult = false;
    this.showError = false;
  }
  isValidInput() {
    if (this.serNumber.length === 12 && this.authCode.replace('-', '').length === 8) {
      return true;
    }
    this.showError =  true;
    return false;
  }
  copyToClipboard() {
    const textarea = document.createElement('textarea');
    textarea.style.height = '0px';
    textarea.style.opacity = '0';
    textarea.style.width = '0px';
    document.body.appendChild(textarea);
    textarea.value = this.maintainKey;
    textarea.select();
    document.execCommand('copy');
    textarea!.parentNode!.removeChild(textarea);
  }
}
